<!--
 * @FileDescription: 地图数据组件
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-08-22 15:52:53
 -->
<template>
  <dv-border-box12 class="map-template" :order="order">
    <div class="map-container" id="map"></div>
    <!-- <div class="feature-descibe" v-if="describeShow">{{ schoolPos }}</div> -->
    <div class="roll-back" @click="rollBackView"></div>
  </dv-border-box12>
</template>

<script>
export default {
  name: 'MapTemplate',
}
</script>

<script setup>
import { defineProps, onMounted, defineEmits, ref } from 'vue';
import { BorderBox12 as DvBorderBox12 } from '@kjgl77/datav-vue3';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// import activeJson from "@/components/activeChartData.json"
import axios from 'axios';


let props = defineProps({
  order: String,
});
console.log(props)

let activeJson = ref({})

let viewState = {
  latitude: 28.660,
  longitude: 117.216,
  zoom: 5.22,
  pitch: 33.50,
  bearing: -7.20
};
// const order = props.order;

// function sleep(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }

let tick = 0;

const emit = defineEmits(['clickSchool']);

let describeShow = ref(false);

// let schoolPos = ref("")

let rollBackView = null;

onMounted(() => {
  axios.get('/activeChartData.json')
    .then(response => {
      activeJson.value = response.data;
    })
    .catch(error => {
      console.log(error);
    });
  const map = new mapboxgl.Map({
    accessToken: 'pk.eyJ1Ijoiam9obm55dCIsImEiOiJja2xxNXplNjYwNnhzMm5uYTJtdHVlbTByIn0.f1GfZbFLWjiEayI6hb_Qvg',    //tzh
    // accessToken: 'pk.eyJ1IjoiMTM0NzczNTgxNzMiLCJhIjoiY2xsbHpsbGc0MWxqYTNwcXVxY3l5Mjk0bCJ9.cBfmWUjcqLeqBWZMZROR2Q',   //dcq
    container: 'map',
    interactive: true,
    style: 'mapbox://styles/johnnyt/clfz9dcd5008801ogyt1to0i4',
    // style: 'mapbox://styles/13477358173/cljsaop2701ab01pkeyiwgbvo',
    // style: "mapbox://styles/13477358173/cljsaop2701ab01pkeyiwgbvo", 

    zoom: viewState.zoom,
    center: [viewState.longitude, viewState.latitude],
    pitch: viewState.pitch,
    bearing: viewState.bearing
  });

  rollBackView = () => {
    map.flyTo({
      zoom: viewState.zoom,
      center: [viewState.longitude, viewState.latitude],
      pitch: viewState.pitch,
      bearing: viewState.bearing
    }, 500);
    if (describeShow.value) {
      describeShow.value = false;
    }
  }
  // console.log("!!!!!!!!!!!!!",activeJson);
  map.on('load', () => {
    map.addSource('unionschoolarea', {
      type: 'geojson',
      data: activeJson.value.unionSchoolPt
    });
    map.addLayer({
      id: 'heatmap-points',
      type: 'heatmap',
      source: 'unionschoolarea',
      paint: {
        "heatmap-opacity": 0.75
      }
    })
    map.addLayer({
      id: 'unionschoolcircle',
      type: 'circle',
      source: 'unionschoolarea',
      paint: {
        "circle-stroke-width": 1,
        "circle-blur": [
          "match",
          [
            "get",
            "construct"
          ],
          [
            1
          ],
          0.4,
          0
        ],
        "circle-color": "rgb(130, 227, 223)",
        "circle-opacity": 0.6,
        "circle-radius": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          0,
          1,
          4.69,
          3,
          5.88,
          5,
          16.17,
          9,
          22,
          15
        ],
        "circle-stroke-opacity": 0.5,
        "circle-stroke-color": "rgb(0, 42, 102)"
      }
    });
    //热力图
    map.addLayer({
          id: 'unionSchoolName',
          type: 'symbol',
          source: 'unionschoolarea',
          paint: {
            "text-color": "rgb(231, 251, 254)",
            "text-opacity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              1,
              7.94,
              0.9,
              8,
              0.9,
              22,
              1
            ]
          },
          layout: {
            "text-field": ["to-string", ["get", "name"]],
            "text-anchor": "bottom",
            "text-offset": [0, 4],
            "text-font": ["YRDZST Heavy", "Arial Unicode MS Regular"],
            "text-size": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              12,
              6,
              12,
              12.85,
              18,
              22,
              32
            ],
            // "text-variable-anchor": [
            //   "bottom",
            //   // "top",
            //   // "top-right",
            //   // "bottom-left",
            //   // "right",
            //   // "left",
            //   // "bottom-right",
            //   // "top-left"
            // ]
          }
        });

    setInterval(() => {
      map.setPaintProperty('unionschoolarea', 'circle-opacity', 0.5 + tick / 20);
      tick = (tick + 1.0) % 10;
    }, 100);

    map.on('mouseenter', ['unionschoolcircle', 'unionSchoolName'], () => {
      map.getCanvas().style.cursor = 'pointer'
    })
    map.on('mouseleave', ['unionschoolcircle', 'unionSchoolName'], () => {
      map.getCanvas().style.cursor = ''
    })

    map.on('click', ['unionschoolcircle', 'unionSchoolName'], async (e) => {
      // map.flyTo({
      //   center: e.features[0].geometry.coordinates,
      //   zoom: 14.6, 
      // }, 1000)
      let clickFeature = e.features[0];
      // await sleep(1500);
      console.log('clicked feature id', clickFeature["properties"]["id"])
      describeShow.value = true;
      // schoolPos.value = clickFeature["properties"]["pos"];

      // console.log("schoolPos.value", schoolPos.value);

      emit("clickSchool", clickFeature["properties"]["id"]);
    })
  })

})

</script>


<style lang="scss" scoped>
$orders: 1, 2, 3, 4, 5, 6, 7, 8;

div.map-template {
  position: relative;
  // margin-top: 1vh;
  // margin-bottom: 1vh;
  width: 100vw;
  height: 84vh;
  z-index: 10;

  @each $order in $orders {
    &[order='#{$order}'] {
      order: $order;
    }
  }


  div.border-box-content {
    width: 36vw;
    height: 82vh;
    border-radius: 10px;

    div.map-container {
      position: absolute;
      top: 0.7%;
      left: 0.7%;
      width: 98.6%;
      height: 98.6%;
      z-index: 10;
      border-radius: 8px;
      overflow: hidden;
    }

    div.feature-descibe {
      position: absolute;
      right: 31vw;
      top: 2vh;
      width: fit-content;
      height: 5vh;
      padding-left: 1vw;
      padding-right: 1vw;
      text-align: center;
      font-size: 2vh;
      border-radius: 3px;
      backdrop-filter: blur(3px);
      line-height: 5vh;
      z-index: 20;
      color: rgb(235, 255, 251);
      background-color: rgba(0, 128, 255, 0.5);
      z-index: 10;
    }

    div.roll-back {
      position: absolute;
      width: 2vw;
      height: 2vw;
      right: 1vw;
      bottom: 4vh;
      z-index: 21;
      // background-color: aqua;
      background-image: url("http://223.2.9.189:8080/image/zoom-in.png");
      background-size: cover;
      transition: all 0.5s ease-in-out;

      &:hover {
        width: 2.5vw;
        height: 2.5vw;
        cursor: pointer;
      }
    }
  }
}
</style>
